<template>
  <v-container>
    <v-row>
      <v-col cols="10" offset="1">
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in details" :key="index">
            <td style="min-width: 250px; max-width: 250px; width: 250px;">{{item.name}}</td>
            <td style="white-space: pre-wrap;">{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col cols="10" offset="1">
        <SectionTitle :title="label('addresses')"/>
        <v-simple-table class="profile-table">
          <tbody>
          <tr v-for="(item, index) in addresses" :key="index">
            <td style="min-width: 250px; max-width: 250px; width: 250px;">{{item.name}}</td>
            <td style="white-space: pre-wrap;">{{item.value}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import _isNull from "lodash/isNull";
  import _isUndefined from "lodash/isUndefined";
  import _isArray from "lodash/isArray";
  import _join from "lodash/join";
  import _map from "lodash/map";
  import _isBoolean from "lodash/isBoolean";
  import SectionTitle from "@/components/atoms/SectionTitle";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "PersonProfileDetails",
    props: {
      "person": {
        type: Object,
        required: true
      },
      "user": {
        type: Object,
        required: true
      },
      "consts": {
        type: Object,
        required: true
      },
      "short": {
        type: Boolean,
        default: false
      },
      "owner": {
        type: Boolean,
        default: false
      }
    },
    computed: {
      details () {
        if (this.short) {
          return []
        }
        const list = [
          { name: this.label("realName"), value: this.fullName },
          { name: this.label("realNameKana"), value: this.fullNameKana },
          { name: this.label("department"), value: this.person.department },
          { name: this.label("tel"), value: this.person.tel }
        ];
        return list;
      },
      fullName () {
        const lastName = this.person.lastName || ""
        const firstName = this.person.firstName || ""
        return lastName + " " + firstName;
      },
      fullNameKana () {
        const lastName = this.person.lastNameKana || ""
        const firstName = this.person.firstNameKana || ""
        return lastName + " " + firstName;
      },
      addresses () {
        const list = [
          { name: this.label("email"), value: this.user.email },
          { name: this.label("cc1"), value: this.person.emailCc1 },
          { name: this.label("cc2"), value: this.person.emailCc2 },
          { name: this.label("cc3"), value: this.person.emailCc3 },
        ];
        return list;
      },
      toText () {
        return (value, items) => {
          if (_isNull(value) || _isUndefined(value) || _isNull(items) || _isUndefined(items)) {
            return ""
          }
          if (_isArray(value)) {
            return _join(_map(value, val => items.filter(item => item.value === val)[0].label), ", ")
          } else if (_isBoolean(value)) {
            return items.filter(item => item.value === (value ? 1 : 0))[0].label
          } else {
            return items.filter(item => item.value === value)[0].label
          }
        }
      }
    },
    components: {SectionTitle}
  }
</script>

<style scoped lang="sass">
.profile-table
  margin: 0 16px
</style>
